const BaseDelayMs = 1000;

export const delay = (exponent: number) =>
    new Promise((resolve) => setTimeout(resolve, BaseDelayMs * 2 ** exponent));
